import { SchoolAdminNewPage } from "./page"

export default SchoolAdminNewPage
